import {Component, OnInit, AfterViewInit, Input, ViewChild, ElementRef, OnChanges, SimpleChanges, OnDestroy} from '@angular/core';
import {LwAverageEnergyGraph} from '../../lw-graphs/average-hourly-graph';
import {DateTime} from 'luxon';
import {LdsUserService} from '../../../services/lds-user.service';
import { HttpClient } from '@angular/common/http';
import {GlobalVariablesService} from '../../../services/global-variables.service';
import {selectAll} from 'd3';
import {ChartJsAverageEnergyGraph} from '../../lw-graphs/chart-js-average-energy';
import { Chart } from 'chart.js';

@Component({
    selector: 'lds-y3-bar-chart',
    templateUrl: './y3-bar-chart.component.html',
    styleUrls: ['./y3-bar-chart.component.css'],
    standalone: false
})
export class Y3BarChartComponent implements OnInit, OnChanges, OnDestroy {
  @Input() data: any;
  @ViewChild('graph', {static: false}) graphArea: ElementRef;
  graph: any;
  loading = true;
  checked: boolean = false;
  octopusData: any;
  octopusUser: boolean = false;

  constructor(public user: LdsUserService, private http: HttpClient, private globalVars: GlobalVariablesService) {
  }

  ngOnDestroy(){
    if(this.graph){
      this.graph.destroy();
    }
  }

  ngOnInit() {
    const validUsers = ['56393490-9edc-4661-b0d0-d3524485af62', '5b7110c4-f071-4dea-9049-7fc169014735', '49f7a96c-3393-4562-bb0b-272d369c00ac', '6e25ab5a-4dd3-40c7-b6e8-36d765d7bd56'];
    this.octopusUser = validUsers.includes(this.user.userDetail.user._id) ? true : false;
  }

  checkMoreThanZero = (data) => {
    const moreThanZero = data.find(element => element.value > 0);
    if (moreThanZero) {
      return data;
    } else {
      data = data.map(element => {
        element.value = null;
        return element;
      });
    }
    return data;
  };

  ngOnChanges(changes: SimpleChanges) {
    const chartExists = Chart.getChart("averageEnergy");
    if(chartExists){
      chartExists.destroy();
    }

    if (changes.data) {
      changes.data.currentValue
        .subscribe((res: any) => {
          this.data = res;
          this.checkMoreThanZero(res);
          if (this.graph) {
            return;
          }

          const chartJsGraph = new ChartJsAverageEnergyGraph(this.globalVars);
          chartJsGraph.draw(res);

          this.graph = chartJsGraph.graph;
          this.loading = false;
          // this.getData(res).subscribe((octRes: any) => {
          //   if (this.checked) {
          //     this.octopusData = octRes.averageRates.map(rate => {
          //       const dt = DateTime.fromISO(rate.valid_from);
          //       const timestamp = dt.toMillis(dt);
          //       const value = rate.avg_value_inc_vat.toFixed(2);
          //       return {
          //         timestamp,
          //         value
          //       }
          //     })
          //   }
          // });
        });
    }
  }

  getData(energyData) {
    const startTimeDate = DateTime.fromMillis(energyData[0].timestamp).toFormat('y-MM-dd');
    const startTimeT = DateTime.fromMillis(energyData[0].timestamp).toFormat('T');
    const endTimeDate = DateTime.fromMillis(energyData[23].timestamp).toFormat('y-MM-dd');
    const endTimeT = DateTime.fromMillis(energyData[23].timestamp).toFormat('T');
    const startTime = `${startTimeDate}T${startTimeT}`;
    const endTime = `${endTimeDate}T${endTimeT}`;
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `bearer ${this.user.userDetail.tokens.access_token}`
    };
    return this.http.get(`https://publicapi.lightwaverf.com/octopus/v1/rate-data?period_from=${startTime}&period_to=${endTime}`, {headers});
  }

  octopusToggle(event) {
    this.checked === event.checked;
    selectAll('.SD-graph-main-avg > .SD-graph > svg').remove();
    this.getData(this.data).subscribe((octRes: any) => {
      if (event.checked) {
        this.octopusData = octRes.averageRates.map(rate => {
          const dt = DateTime.fromISO(rate.valid_from);
          const timestamp = dt.toMillis(dt);
          const value = rate.avg_value_inc_vat.toFixed(2);
          return {
            timestamp,
            value
          };
        });
      }
      this.checkMoreThanZero(this.data);
      this.graph = new LwAverageEnergyGraph(this.graphArea.nativeElement);
      this.loading = false;

      if (event.checked) {
        this.graph.draw([this.data, this.octopusData]);
      } else {
        this.graph.draw([this.data]);
      }
    });
  }
}
